export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8683.3db82865.jpg";